// extracted by mini-css-extract-plugin
export default {"root":"styles_root__Zn2hE","l":"styles_l__M4TMd","m":"styles_m__mFXIL","s":"styles_s__dgGLy","light":"styles_light__kA91w","dark":"styles_dark__O1vGK"};